<template>
    <div class="charge-warp">
        <div class="display-f just-b align-i-c">
            <el-form ref="form" :model="searchForm" inline>
                <el-form-item label="就诊日期：">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.date" type="daterange"  @change="timeChange"
                        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="$session.get('deptId') == 0">
                  <el-select v-model="searchForm.deptId" placeholder="医馆名称" clearable>
                    <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="医生姓名" v-model="searchForm.doctorName"></el-input>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="handleReset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button type="primary" plain @click="handleExport">导出</custom-button>

        </div>
        <div class="table-warp">
            <customTable :cell-style="{ borderColor: '#DDDDDD' }" height="600" tooltip-effect="dark" :currentPageSize="searchForm.pageSize"
                @pageChange="pageChange" :currentPage="searchForm.pageNum" :total="total" :tableData="tableData"
                :column="column" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO,deptDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, isNull, debounce,dictText } from '@/utils/validateBase'
import { registerStatusList } from '@/utils/const'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            searchForm: {
                date: [],
                doctorName: '',
                pageNum: 1,
                pageSize: 20,
                deptId: this.$session.get('deptId') == 0 ? null : this.$session.get('deptId'),
            },//搜索条件
            tableData: [],//表格数据
            total: 0,//总数
            totalData: 0,//金额合计
            column: [
                { label: "医馆名称", prop: "deptName", align: 'left' },
                { label: "医生姓名", prop: "doctorName", align: 'left',},
                { label: "挂号费", prop: "regisPrice", align: 'left',},
                { label: "优惠券", prop: "couponPrice", align: 'left',},
                { label: "挂号费实收", prop: "realPrice", align: 'left',},
                { label: "就诊日期", prop: "seeOrderDate", align: 'left', formatter:(row)=>{ return  isNull(row.seeOrderDate) ? '' : Utils.timeFormat(row.seeOrderDate,'yyyy-MM-DD')  } },
                { label: "会员手机号", prop: "memberPhone", align: 'left',},
                { label: "患者姓名", prop: "patientName", align: 'left',},
                { label: "患者手机号", prop: "patientPhone", align: 'left',},
                { label: "状态", prop: "status", align: 'left',formatter:(row)=>{ return dictText(row.status, registerStatusList)}},
                { label: "对应收费单实付金额", prop: "paymentRealPrice", align: 'left',},
            ],//表头
            deptList: [],//医馆列表
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
      console.log(this.$session.get('deptId'),8888);
      
        let time = CommonDTO.getSystemTimeDTO()
        let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
        let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
        this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD')
        this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD')
        this.getListData()
        this.getDeptList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        //获取所有医馆
        async getDeptList() {
          this.deptList = await deptDTO.getDeptList()
        },
        /**
         * 页码改变
         */
        pageChange(obj) {
            let { current, size } = obj
            this.searchForm.pageNum = current
            this.searchForm.pageSize = size
            this.getListData()
        },
        /**
         * 重置
         */
        handleReset() {
            this.searchForm = {
                date: [],
                doctorName: '',
                deptName: '',
                pageNum: 1,
                pageSize: 20,
                deptId: this.$session.get('deptId') == 0 ? null : this.$session.get('deptId'),
            }
            let time = CommonDTO.getSystemTimeDTO()
            let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
            let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
            this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD')
            this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD')
            this.getListData()
        },

        /**
         * 搜索
         */
        handleSearch() {
            this.searchForm.pageNum = 1
            let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
            this.getListData()
        },

        /**
         * 查询报表数据
         */
        async getListData() {
            this.searchForm.startTime = this.searchForm.date[0]
            this.searchForm.stopTime = this.searchForm.date[1] 
            let { code, data } = await statementDTO.getCouponData(this.searchForm)
            if (code == 200) {
                this.tableData = data && data.page.rows
                if(data.page.total > 0){
                  this.tableData.push({
                  deptName:'合计',
                  ...data.couponReportAmountResp
                  })
                }
                this.total = data.page.total
            }
        },

        /**
        * 导出
        */
        handleExport: debounce(function () {
            this.searchForm.startTime = this.searchForm.date[0]
            this.searchForm.stopTime = this.searchForm.date[1] 
            statementDTO.couponExport(this.searchForm, { name: '优惠券统计'}).then(res => {
             })
        }, 1000, true),
        timeChange(val){
          val[0]= Utils.timeFormat(Number(Utils.startOfDay(val[0])), 'yyyy-MM-DD')
          val[1] = Utils.timeFormat(Number(Utils.endOfDay(val[1])), 'yyyy-MM-DD')
        }

    },
}
</script>
<style lang="less" scoped>
.charge-warp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .el-form-item {
        margin-bottom: 0;
    }

    .table-warp {
        margin-top: 16px;
        flex: 1;

        /deep/.el-table {
            border-color: #DDDDDD;
        }

        /deep/.pagination-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 0;

            .total-tips {
                color: #667182;
                font-size: 14px;
            }
        }
    }
}
</style>